export const GOOGLE_MAP_KEY = 'AIzaSyCdESbImjqv0sav8Bz4SRjpL9-rQBcz2Ek'